import {
  Card,
  Heading,
  Icon,
  Stack,
  Text
} from '@leroy-merlin-br/backyard-react'

import { CATEGORY_ICONS } from './categoryIcons'
import { FAQ_DATA } from './constants'
import * as S from './styled'

const NewFaqList = () => (
  <S.Grid>
    {FAQ_DATA.map(({ category, slug, questions }) => (
      <S.CategoryLink key={slug} to={`/duvidas/${slug}`}>
        <Card>
          <Stack space="byte" alignX="center">
            <Icon as={CATEGORY_ICONS[slug]} size="giga" color="primary" />
            <Heading size="mega" noMargin>
              {category}
            </Heading>
            <Text color="n600" noMargin>
              {questions.length} perguntas
            </Text>
          </Stack>
        </Card>
      </S.CategoryLink>
    ))}
  </S.Grid>
)

export default NewFaqList
